var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Randoge',{attrs:{"url":this.image}}),_c('DogePrice',{attrs:{"amount":this.price,"happ":this.happ}}),_c('DogeSays',{attrs:{"happ":_vm.happ}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }